import { useEffect } from 'react';

const useLoadAtTop = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
};

export default useLoadAtTop;
